import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { X, Save } from "lucide-react";

export default function ModalDisabledDays({ isModalOpen, setIsModalOpen, onSaveDisabledDays }) {
  const [disabledDays, setDisabledDays] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  const handleAddDisabledDay = () => {
    if (!selectedDate) return;
    if (disabledDays.includes(selectedDate)) return; 
    setDisabledDays([...disabledDays, selectedDate]);
    setSelectedDate("");
  };

  const handleRemoveDisabledDay = (date) => {
    const updatedDisabledDays = disabledDays.filter((d) => d !== date);
    setDisabledDays(updatedDisabledDays);
  };

  const handleSave = () => {
    onSaveDisabledDays(disabledDays);
    setIsModalOpen(false);
  };

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setIsModalOpen(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-lg shadow-xl p-6 font-sans w-full max-w-lg mx-4 border border-gray-200 flex flex-col max-h-[90vh] overflow-y-auto"
          >
            <h2 className="text-xl font-semibold mb-4 text-text">Deshabilitar Días Específicos</h2>

            <div className="mb-4">
              <label className="block text-sm font-medium text-text mb-1">Seleccionar Fecha</label>
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="px-3 py-1.5 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 w-full text-sm"
              />
              <button
                onClick={handleAddDisabledDay}
                className="mt-2 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors w-full sm:w-auto"
              >
                Agregar Fecha
              </button>
            </div>

            <div className="space-y-2">
              {disabledDays.map((date, index) => (
                <div key={index} className="flex justify-between items-center p-2 border border-gray-200 rounded-md">
                  <span className="text-text">{date}</span>
                  <button
                    onClick={() => handleRemoveDisabledDay(date)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <X/>
                  </button>
                </div>
              ))}
            </div>

            <div className="mt-6 flex flex-col sm:flex-row justify-end gap-3">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors w-full sm:w-auto flex items-center justify-center gap-2"
              >
                <X className="w-4 h-4" />
                <span>Cancelar</span>
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors w-full sm:w-auto flex items-center justify-center gap-2"
              >
                <Save className="w-4 h-4" />
                <span>Guardar Cambios</span>
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}